export class GameQuest {
  constructor(quest) {
    this._quest = quest;
    this._id = this._quest.id;
    this._cat = this._quest.category || 0;
    this._objectives = []; // indexes can be 0,1,2 to store the status of objectives. 0 (or undefined/null) is not yet complete, 1 is completed, 2 is failed
    this._resolution = false; // the selected resolution to display under the quest description in the quest log. false for none.
    this._status = 0;      // 0 is active, 1 is completed, 2 is failed
    this.type = 'Quest'
  }

  description() {
    return this._quest.description;
  };

  name() {
    return this._quest.name;
  }

  chapter() {
    return this._quest.chapter;
  };

  category() {
    return this._quest.category;
  };

  objectives() {
    return this._quest.objectives;
  };

  resolutions() {
    return this._quest.resolutions;
  };

  hasResolution() {
    return this._resolution;
  };
}
